module.exports = __webpack_public_path__ + "img/aboutUs.8e67df3f.png";